
import { z } from "zod";

export const TaskReadinessValues = ["READY", "SCHEDULED", "BLOCKED", "COMPLETE", "CANCELED", "PARKED"] as const;
export const TaskReadinessSchema = z.enum(TaskReadinessValues);
export const TaskReadiness = TaskReadinessSchema.enum;
export type TaskReadiness = (typeof TaskReadinessValues)[number];
